<template>
  <div
    class="senior-list-component app-flex-row"
    :style="{ margin: `0 -${gutter}px` }"
  >
    <a
      v-for="item in list"
      :key="item.id"
      class="senior-item font-color-body"
      :style="{ marginLeft: `${gutter}px`, marginRight: `${gutter}px` }"
      :href="`https://hd.weibo.com/senior/view/${item.id}?alk_from=P006_C070`"
      target="_blank"
      @click="() => itemClick(item)"
    >
      <img
        v-lazy="item.banner"
        class="banner app-lazyload-transparent"
        :title="`微博营销 营销案例 ${item.activity_name}`"
        :alt="`微博营销 营销案例 ${item.activity_name}`"
      />
      <div class="info app-flex-column">
        <p class="brand font-14 font-color-desc">
          <span class="label">品牌方：</span>
          <span>{{ item.brand.name }}</span>
        </p>
        <h4 class="title font-18">{{ item.activity_name }}</h4>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    list: { type: Array, default: () => [] },
    gutter: { type: [Number, String], default: 12 },
    itemClick: { type: Function, default: () => {} }
  }
}
</script>

<style lang="scss" scoped>
.senior-list-component {
  justify-content: flex-start;
  .senior-item {
    width: 278px;
    height: 271px;
    border-radius: 3px;
    overflow: hidden;
    background-color: $neutral-color-1;
    cursor: pointer;
    .banner {
      width: 100%;
      height: 139px;
      object-fit: cover;
    }
    .info {
      padding: 14px 16px 0;
      .title {
        font-weight: bold;
        margin-top: 12px;
      }
    }
  }
}
</style>
